import React from 'react';
import { CustomTypeOptions, Normalize, useTranslation } from 'react-i18next';

interface Props {
	tx: CustomTypeOptions['allRes']; // TODO: to be typed properly later
	ns?: keyof CustomTypeOptions['resources'];
	values?: Record<string, unknown>;
}

const Tx = ({ tx, ns, values }: Props) => {
	const { t } = useTranslation();

	return (
		<>
			{t(
				tx as Normalize<
					CustomTypeOptions['resources'][CustomTypeOptions['defaultNS']] // Ignore karo, jugaad bithaa rakha hoon
				>,
				{
					ns,
					...values,
				}
			)}
		</>
	);
};

export default Tx;
